import {
  assertValidActivityPayload,
  buildActivityPayload as buildLegacyActivityPayload,
  type ActivityInsert,
  type ActivityUpdate,
} from '../../activities/schema'
import type { ActivityPayload, ActivityRow } from '../types/database.types'

export function buildActivityPayload(
  input: Record<string, unknown>,
  mode: 'insert' | 'update' = 'insert',
): ActivityPayload {
  const payload = buildLegacyActivityPayload(input, mode) as
    | ActivityInsert
    | ActivityUpdate
  assertValidActivityPayload(payload)
  return payload
}

export function mapActivityRow(row: Record<string, unknown>): ActivityRow {
  return row as ActivityRow
}
